import React, { useState } from "react"
import { attemptLogin } from "../store"
import { useNavigate, Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import "./styles/Login.css"

const Login = () => {
  const auth = useSelector((state) => state.auth)
  const navigate = useNavigate()

  const dispatch = useDispatch()
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  })

  const onChange = (ev) => {
    setCredentials({ ...credentials, [ev.target.name]: ev.target.value })
  }

  const login = (ev) => {
    ev.preventDefault()
    dispatch(attemptLogin(credentials))
  }
  if (!!auth.id) {
    navigate("/products")
  }
  return (
    <div className="loginMasterWrapper">
      <div className="loginWrapper">
        <i style={{ "--clr": "#00ff0a" }}></i>
        <i style={{ "--clr": "#ff0057" }}></i>
        <i style={{ "--clr": "#fffd44" }}></i>
        <div className="loginCard">
          <h2 className="loginTitle">Login</h2>
          <form onSubmit={login} className="loginForm">
            <input
              placeholder="username"
              value={credentials.username}
              name="username"
              onChange={onChange}
              className={
                credentials.username.length > 0
                  ? "inputField primary"
                  : "inputField warning"
              }
            />
            <input
              placeholder="password"
              name="password"
              type="password"
              value={credentials.password}
              onChange={onChange}
              className={
                credentials.password.length > 0
                  ? "inputField primary"
                  : "inputField warning"
              }
            />
            <button className="loginBtn">Sign In</button>
          </form>
          <Link to="/account/create" className="signupLink">
            No Account? Sign Up Here
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Login
